<script lang="ts">
	import type { PostFiltersSchema } from '$src/utils/api/feed.util';
	import InputMain from '$lib/components/common/inputs/textInputs/GlobalTextInput.svelte';
	import { MEDIA_FILE_TYPES } from 'garden-common/index';

  export let detail: PostFiltersSchema['typeOfFileFormat'] = { fileFormats: [] };
  export let isValid: boolean;

  let _fileFormats: string;

  if (detail.fileFormats) {
    _fileFormats = detail.fileFormats.join(', ');
  }

  $: detail.fileFormats = _fileFormats
    ? (_fileFormats
        .replaceAll(' ', '')
        .split(',')
        .map(v => v.trim().toUpperCase())
        .filter(v => v) as (typeof MEDIA_FILE_TYPES)[number][])
    : [];

  $: isValid =
    detail.fileFormats?.length &&
    detail.fileFormats.filter(v => !MEDIA_FILE_TYPES.includes(v)).length === 0;
</script>

<InputMain
  label="File formats"
  bind:value={_fileFormats}
  caption="File formats separated by commas"
  danger={!isValid}
  dangerMessage="Valid file types are {MEDIA_FILE_TYPES.join(', ')}"
/>
